module.exports = __webpack_public_path__ + "assets/img/cooking.d5a05c5a.svg";